import React, { useState } from "react";
import { Help, HelpModalProps } from "../Help";
import HelpOutlined from "../Icon/HelpOutlined";
import "./styles.scss";

const CoverModalButton = ({ items, ...modalProps }) => {
  const [opened, setOpen] = useState(false);
  return (
    <>
      <span className="cover_modal_icon" onClick={() => setOpen(true)}>
        <HelpOutlined />
      </span>
      <Help.Modal
        show={opened}
        onClose={() => setOpen(false)}
        items={items}
        {...modalProps}
      />
    </>
  );
};

CoverModalButton.propTypes = {
  ...HelpModalProps,
};

export default CoverModalButton;
